import { Message } from 'element-ui';
import NProgress from 'nprogress'
import Cookies from 'js-cookie'
import 'nprogress/nprogress.css'
jQuery.support.cors=true;



$.ajaxSetup( {
    url:  "/portal/vue/YfPortalServlet", // 默认URL
    async:false, // 默认同步加载
    dataType:"json",   //返回格式为json
    type: "POST" , // 默认使用POST方式
    // 默认添加请求头
    // headers: { 
    //     "Author": "CodePlayer" ,
    //     "Powered-By": "CodePlayer" 
    // } ,
    beforeSend:function(){
      
        //请求前的处理
    },
    success:function(){
      
    },
    error: function(jqXHR, textStatus, errorMsg){ // 出错时默认的处理函数
        // jqXHR 是经过jQuery封装的XMLHttpRequest对象
        // textStatus 可能为： null、"timeout"、"error"、"abort"或"parsererror"
        // errorMsg 可能为： "Not Found"、"Internal Server Error"等
        let errType = errorMsg.name
        if( errType.indexOf('NetworkError')!=-1){
            Message.error("网络错误")
        }else if( errType.indexOf('Not Found')!=!1){
            Message.error("十分抱歉，请求资源未找到")
        }else{
            Message.error("十分抱歉，无法从服务器获得数据")
        }
        // 提示形如：发送AJAX请求到"/index.html"时出错[404]：Not Found
        console.warn( '发送AJAX请求到"' + this.url + '"时出错[' + jqXHR.status + ']：' + errorMsg );        
    }
} );


let ajax={}
ajax.get = function(data,callback){
    var backData=null
    doAjax("get",data,function(data){
        backData =data;
    })
    return backData
}
ajax.post= function(data,callback){
    var backData=null
    doAjax("post",data,function(data){
        backData =data;
    })
    return backData
}

//process.env.API_URL
function doAjax(type,data,callback){
    const portalToken= Cookies.get('portalToken')||''
    NProgress.start();
    $.ajax({
        data:data,    //参数值
        type:type,   //请求方式
        headers: { 
        "portalToken":portalToken,
        } ,
        success:function(data){
            NProgress.done()
            callback(data)
        },
    });
}


export default ajax;


// WEBPACK FOOTER //
// ./src/utils/ajax.js